import { fromDatetimeInputToISO } from '@/common/utils/date/fromDatetimeInputToISO.util';
import { Injectable } from '@angular/core';

export interface Reservation {
    location?: string[] | null;
    differentLocation?: string[] | null;
    startDate?: string | null;
    endDate?: string | null;
    startHour?: string | null;
    endHour?: string | null;
    discountCode?: string | null;
    age?: number | null;
    sessionId?: string | null;
    currency?: string | null;
    flowType?: 'office' | 'prepaid';
    origin?: 'NAT' | 'INT';
    cityInternational?: any;
    isUpgradePromotion?: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CurrentReservationService {
    private _current: Reservation = {
        age: 25,
    };

    public get current(): Reservation {
        return this._current;
    }
    public set current(v: Reservation) {
        this._current = v;
    }

    private _startHours: any[] = [];
    public get startHours(): any[] {
        return this._startHours;
    }
    public set startHours(v: any[]) {
        this._startHours = v;
    }

    private _endHours: any[] = [];
    public get endHours(): any[] {
        return this._endHours;
    }
    public set endHours(v: any[]) {
        this._endHours = v;
    }

    private _locations: any[] = [];
    public get locations(): any[] {
        return this._locations;
    }
    public set locations(v: any[]) {
        this._locations = v;
    }

    private _differentLocations: any[] = [];
    public get differentLocations(): any[] {
        return this._differentLocations;
    }
    public set differentLocations(v: any[]) {
        this._differentLocations = v;
    }

    private _showDifferenteLocation = false;
    public get showDifferenteLocation(): boolean {
        return this._showDifferenteLocation;
    }
    public set showDifferenteLocation(v: boolean) {
        this._showDifferenteLocation = v;
    }

    private _discountCode: any[] = [];
    public get discountCode(): any[] {
        return this._discountCode;
    }
    public set discountCode(v: any[]) {
        this._discountCode = v;
    }

    public get startDatetime(): string {
        return fromDatetimeInputToISO(
            this.current.startDate as string,
            this.current.startHour as string,
        );
    }

    public get endDatetime(): string {
        return fromDatetimeInputToISO(
            this.current.endDate as string,
            this.current.endHour as string,
        );
    }

    private _locationName = '-';
    public set locationName(value: string) {
        this._locationName = value;
    }
    public get locationName(): string {
        return this._locationName;
    }

    private _differentLocationName = '-';
    public set differentLocationName(value: string) {
        this._differentLocationName = value;
    }
    public get differentLocationName(): string {
        return this._differentLocationName;
    }

    private _vehicle: any;
    public get vehicle(): any {
        return this._vehicle;
    }
    public set vehicle(v: any) {
        this._vehicle = v;
    }

    private _total: any = {};
    public get total(): any {
        return this._total;
    }
    public set total(v: any) {
        this._total = v;
    }

    private _locationSelected: any;
    public get locationSelected(): any {
        return this._locationSelected;
    }
    public set locationSelected(v: any) {
        this._locationSelected = v;
    }

    private _insurances: any[] = [];
    public get insurances(): any[] {
        return this._insurances;
    }
    public set insurances(v: any[]) {
        this._insurances = v;
    }

    private _products: any[] = [];
    public get products(): any[] {
        return this._products;
    }
    public set products(v: any[]) {
        this._products = v;
    }

    private _isUpgradePromotion = false;
    public get isUpgradePromotion(): boolean {
        return this._isUpgradePromotion;
    }
    public set isUpgradePromotion(v: boolean) {
        this._isUpgradePromotion = v;
    }
    private _upgradeCatergoryPromotion: any;
    public get upgradeCatergoryPromotion(): any {
        return this._upgradeCatergoryPromotion;
    }
    public set upgradeCatergoryPromotion(v: any) {
        this._upgradeCatergoryPromotion = v;
    }
}
